export const getLocalBusinessSchema = () => ({
  "@context": "https://schema.org",
  "@type": ["EducationalOrganization", "LocalBusiness"],
  "name": "KLM Home Tuitions",
  "image": "https://klmhometuitions.website/logo192.png",
  "url": "https://klmhometuitions.website",
  "telephone": "+91-7386078298",
  "priceRange": "₹₹",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "reviewCount": "142"
  },
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Hyderabad City Center",
    "addressLocality": "Hyderabad",
    "addressRegion": "Telangana",
    "postalCode": "500001",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 17.385044,
    "longitude": 78.486671
  },
  "areaServed": [
    "Hyderabad",
    "Gachibowli",
    "Jubilee Hills",
    "Hitech City",
    "Madhapur",
    "Kukatpally",
    "Banjara Hills",
    "Secunderabad",
    "Ameerpet",
    "Dilsukhnagar"
  ],
  "openingHoursSpecification": {
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    "opens": "08:00",
    "closes": "20:00"
  },
  "sameAs": [
    "https://klmhometuitions.website"
  ]
});

export const getFaqSchema = (faqItems) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqItems.map(item => ({
    "@type": "Question",
    "name": item.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": item.answer
    }
  }))
});
